angular.module('shared').factory('FormFieldDisplayingService', function() {
  return {
    isDisplaying: function(contactType, field) {
      if (field.archived) {
        return false;
      }
      switch (contactType) {
        case 'prospect':
          return field.on_prospect;
        case 'member':
          return field.on_member;
        case 'non_attending_contact':
          return field.on_non_attending_contact;
        default:
          return false;
      }
    }
  };
});
